import { render, staticRenderFns } from "./protocolq.vue?vue&type=template&id=beeb077e&"
import script from "./protocolq.vue?vue&type=script&lang=js&"
export * from "./protocolq.vue?vue&type=script&lang=js&"
import style0 from "./protocolq.vue?vue&type=style&index=0&id=beeb077e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports